<template>
  <div v-if="tips.length > 0" class="panel panel-primary ee-tip">
    <b-carousel ref="tipDetails" 
      indicators
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      id="TipDetails" v-model="slide" :interval="interval">
      <!-- Slides -->
      <b-carousel-slide v-for="(item, index) in tips" :key="index"  :style="{ background: backgroundColor.length > 0 ? '#' + backgroundColor + '!important' : 'transparent !important' }">
        <div class="divWrapper">
          <div class="divContent">
            <p class="bottom10" :style="titleStyle">{{ item.Title }}</p>
            <p class="bottom10" :style="teaserStyle">{{ item.Teaser }}</p>
            <p v-html="item.Description" :style="itemDescriptionStyle"></p>
            <hr style="width:100% " />
          </div>
        </div>
      </b-carousel-slide>
      <template #controls>
        <b-button v-if="isPaused" class='bx-btn resume-btn' @click="togglePause" />
        <b-button v-else class='bx-btn pause-btn' @click="togglePause" />
        <b-button class="bx-btn bx-controls-direction previous-btn" @click="prevSlide" />
        <b-button class="bx-btn bx-controls-direction next-btn" @click="nextSlide">Next</b-button>
      </template>
    </b-carousel>
  </div>
  <div v-else style="border: none;"></div>
</template>

<script>
import axios from "axios";
import { BCarousel, BCarouselSlide, BButton, BCarouselNav, BCarouselIndicators } from 'bootstrap-vue';

export default {
  name: "EnergyEfficiencyTips",
  data() {
    return {
      loading: true,
      isMobile: false,
      hasLoaded: false,
      tips: [],
      backgroundColor: '',
      titleStyle: '',
      teaserStyle: '',
      itemDescriptionStyle: '',
      activeIndex: 0,
      isPaused: false,
      interval: 10000
    }
  },
  components: {
    BCarousel,
    BCarouselSlide,
    BButton,
    BCarouselNav,
    BCarouselIndicators
  },
  mounted() {
    this.isMobile = !this.$store.getters.getIsDesktop;
    this.hasLoaded = this.$store.getters.getEEtipsHasLoaded;
    if (this.hasLoaded) {
      this.loading = false;
      this.tips = this.$store.getters.getEETips;
      if (this.tips.length > 0) {
        this.backgroundColor = this.$store.getters.getEETipBackgroundColor;
        this.titleStyle = this.$store.getters.getEETipsTitleStyle;
        this.teaserStyle = this.$store.getters.getEETipTeaserStyle;
        this.itemDescriptionStyle = this.$store.getters.getEETipItemDescriptionStyle;
      }
    } else {
      this.loadEnergyEfficiencyTips();
    }
  },
  methods: {
    loadEnergyEfficiencyTips() {
      axios.get(this.$httpAxiosBaseUrl() + "Home/LoadEnergyEfficiencyTips?isMobile=" + this.isMobile)
        .then(response => {
          //they came to this page directly and it does not need to count as the data fetching
          if (response === 'NotLoggedIn') return;
          this.$store.commit('EEtipsHasLoaded', true);
          if (response.data && response.data.tips.length > 0) {
            this.tips = response.data.tips;
            this.backgroundColor = response.data.backgroundColor;
            this.titleStyle = response.data.titleStyle;
            this.teaserStyle = response.data.teaserStyle;
            this.itemDescriptionStyle = response.data.itemDescriptionStyle;
            this.$store.commit('setEEtips', response.data.tips);
            this.$store.commit('setEETipBackgroundColor', response.data.backgroundColor);
            this.$store.commit('setEETipsTitleStyle', response.data.titleStyle);
            this.$store.commit('setEETipsTeaserStyle', response.data.teaserStyle);
            this.$store.commit('setEETipsItemDescriptionStyle', response.data.itemDescriptionStyle);
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('Error loading tips:', error);
          this.loading = false;
        });
    },
    isActive(index) {
      return index === this.activeIndex;
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },      
    togglePause() {
      this.isPaused = !this.isPaused;
      if (this.isPaused) {
        this.interval = 0;
      } else {
        this.nextSlide();
        this.interval = 10000;
      }
    },
    prevSlide() {
      this.$refs.tipDetails.prev();
    },
    nextSlide() {
      this.$refs.tipDetails.next();
    }
  }
}
</script>

<style>
.ee-tip {
    position: relative; 
    margin: 0 auto 60px;
    box-shadow: none;
    width: 100%;
}
.divWrapper {
  border-bottom:1px;
}
.divContent {
  padding-left: 40px;
  padding-right: 40px;
  font-size: 14px;
  width:100%
}
.custom-nav {
  align-self: flex-end;
}

.custom-controls {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
}
/* I had to override these to work with our menus properly */
.carousel-caption {
    position: static; 
    z-index: 1; 
    width: 100%; 
}
.carousel-item {
    display: none; 
    color: black !important;
}
.carousel-indicators {
    text-align: left;
    left: 32%;
}
.carousel-indicators li, .carousel-indicators li:hover {
    background-color: #666; 
    display: block;
    width: 10px; 
    height: 10px; 
    margin: 0;
    margin-right: 10px;
    cursor: pointer;
		float: left; 
		list-style: none; 
		position: relative;
    border-radius: 5px; 
    border: 1px;
}

.carousel-indicators li.active, .carousel-indicators li.active:hover {
    background: black !important; 
    display: block;
    width: 10px; 
    height: 10px; 
    margin: 0;
    margin-right: 10px;
    cursor: pointer;
		float: left; 
		list-style: none; 
		position: relative;
    border-radius: 5px; 
    border: 1px;
}
.active {
  border-bottom: none !important;
}
.carousel-caption {
  display: block; 
  box-shadow: none !important;
  padding: 5px;
  min-height: 150px;
  text-align: left;
	color: #333333;
  text-shadow: none;
  padding: 5px;
}

.carousel-container {
  position: relative;
  box-shadow:0 0 5px #ccc;

}
/*I took these from the bxslider from the customer portal and adapted them to the vue-slider*/
.bx-btn, .bx-btn:hover, .bx-btn:focus {
  position: absolute;
  bottom: 13px;
  right: 0;
  display: block;
  text-indent: -9999px;
  width: 9px;
  height: 11px;
  outline: 0;
  margin: 0 3px;
  background-color: transparent !important;
  border: none !important;
}

.bx-controls-direction, .bx-controls-direction:hover, .bx-controls-direction:focus
{
  position: absolute;
  top: 50%;
  margin-top: -16px;
  outline: 0;
  width: 32px;
  height: 32px;
  text-indent: -9999px;
  z-index: 9999;
  padding: 0;
}

.pause-btn, .pause-btn:hover, .pause-btn:focus {
  background: url('../../assets/img/controls.png') no-repeat -86px -44px;
}
.resume-btn, .resume-btn:hover .resume-btn:focus {
  background: url('../../assets/img/controls.png') no-repeat -86px -11px;
}
.previous-btn {
  left: 3px;
  background: url('../../assets/img/controls.png') no-repeat 0 -32px;
}
.next-btn {
  right: 3px;
  background: url('../../assets/img/controls.png') no-repeat -43px -32px;
}

</style>